import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { applyBrand } from '@pos/shared';
import { neutralBrand } from '@pos/tokens';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { DialogHost } from '@/app/DialogHost';
import { Providers } from '@/app/Providers';
import { store } from '@/app/store';
import { router } from '@/routes';

import '@/shared/styles/global.css';

// The tab title and favicon, from the token package rather than the static HTML. Neutral at
// boot: the access token is memory-only, so a cold load is always signed out and the address
// bar is the only hint of a shop. `DashboardShell` re-stamps it once there is a session.
applyBrand(neutralBrand.dashboard);

const container = document.getElementById('root');

if (container === null) {
  throw new Error('The #root element is missing from index.html — the app has nowhere to mount.');
}

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <Providers>
        <RouterProvider router={router} />
        {/* Outside the router: a dialog must survive a navigation, and the revoked-session
            handler fires from the base query with no route in scope. */}
        <DialogHost />
      </Providers>
    </Provider>
  </StrictMode>,
);
